import { render, staticRenderFns } from "./RecipientsCounter.vue?vue&type=template&id=cdde3dd6&scoped=true"
import script from "./RecipientsCounter.vue?vue&type=script&lang=js"
export * from "./RecipientsCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdde3dd6",
  null
  
)

export default component.exports